/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_SubtitleInputs */

const en_us2_coach_subtitle = /** @type {(inputs: Coach_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers based on studies`)
};

const pt_br2_coach_subtitle = /** @type {(inputs: Coach_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respostas com base em estudos`)
};

const es_419_coach_subtitle = /** @type {(inputs: Coach_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuestas basadas en estudios`)
};

const pt_pt2_coach_subtitle = /** @type {(inputs: Coach_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respostas com base em estudos`)
};

const fr_fr2_coach_subtitle = /** @type {(inputs: Coach_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des réponses fondées sur des études`)
};

const de_de2_coach_subtitle = /** @type {(inputs: Coach_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten auf Basis von Studien`)
};

const it_it2_coach_subtitle = /** @type {(inputs: Coach_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposte basate su studi`)
};

/**
* | output |
* | --- |
* | "Answers based on studies" |
*
* @param {Coach_SubtitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_subtitle = /** @type {((inputs?: Coach_SubtitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_SubtitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_subtitle(inputs)
	if (locale === "es-419") return es_419_coach_subtitle(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_subtitle(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_subtitle(inputs)
	if (locale === "de-DE") return de_de2_coach_subtitle(inputs)
	if (locale === "it-IT") return it_it2_coach_subtitle(inputs)
	return en_us2_coach_subtitle(inputs)
});
export { coach_subtitle as "coach.subtitle" }